import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import config from '@plone/volto/registry';
import matomoTracker from '@datapunt/matomo-tracker-js';

export default function Matomo() {

  const [cookies] = useCookies();
  let tracker;

  if (__CLIENT__) {
    if (config.settings.PrivacyPolicy.tracker.type) {
    // if type none, don't create tracker 
      tracker = new matomoTracker({
        urlBase: config.settings.PrivacyPolicy.tracker.urlBase,
        siteId: config.settings.PrivacyPolicy.tracker.id,
      });
    }
  }

  
  useEffect(() => {
    if (config.settings.PrivacyPolicy.tracker.type) {
    tracker.trackPageView();
  }}, [tracker]);
   
  return null;
};


